var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('LightSetting',{attrs:{"locationIntegration":_vm.locationIntegration,"LocationId":_vm.LocationId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }